/** 
 * @type {import("./defs").StoreProjectRating} 
 */
const store = {
}
/** 
* @returns {import("./defs").StoreProjectRating} 
*/
export default function () {
    return JSON.parse(JSON.stringify(store));
}


// WEBPACK FOOTER //
// ./resources/js/storers/StoreProjectRating.js